export default "__VITE_ASSET__D7cV04Hw__"